import * as angular from "angular";
import {IController} from "angular";

export class ExpensesCategoriesTableComponent implements IController {
  infiniteScroll: any;
  onArchive: Function;
  onEdit: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.expenses')
  .component('expensesCategoriesTable', {
    bindings: {
      infiniteScroll: '<',
      onArchive: '&',
      onEdit: '&'
    },
    template: require('./expenses-categories-table.html').default,
    controller: ExpensesCategoriesTableComponent
  });

